
import {  GET_ALL_HOTSPOT_ERROR, GET_ALL_HOTSPOT_POST_ERROR, GET_ALL_MODIS_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    results:[],
    success:false,
}, action) => {
    switch (action.type) {
        case GET_ALL_HOTSPOT_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: action.payload.message,
            };
            break;
        case GET_ALL_MODIS_SUCCESS:
            return {
                ...state,
                error: state.error,
                loading:false,
                results: action.payload,
                success:true,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'MODIS retrieved Successfully',
            };
            break; 
            
        case GET_ALL_HOTSPOT_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieve Error | ' + state.error,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/hotspotRawMODISReducer.js